import { createPackageLogger, isDebugMode } from '@cloudbeds/frontend-logger';

export { isDebugMode };

/**
 * Simple custom log for given file name.
 * Only logs if __debug_mode is set in localStorage.
 * - Note: exception is log.error, which is always logged.
 *
 * Example usage:
 * ```
 * const logLocal = createLogLocal('CardReader.tsx');
 *
 * logLocal('onSubmit', 'Card data parsed');
 * // Output: [CR] [CardReader.tsx] onSubmit :: Card data parsed
 *
 * logLocal('onSubmit', 'cardData:', cardData);
 * // Output: [CR] [CardReader.tsx] onSubmit :: cardData: { ... }
 *
 * logLocal.error('onSubmit', 'Error occurred');
 * // Output: [CR] [CardReader.tsx] onSubmit :: Error occurred
 * // Note: in this case, it's logged as an error message, and logs
 * // even if __debug_mode is not set.
 * ```
 */
export const createLogLocal = createPackageLogger('CR', {
  pkgNameStyles:
    'background: #2c7a7b; color: white; padding: 2px 2px 2px 4px; margin-left: 1px; border-radius: 3px;',
});
